import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LocusRobotics_ds_get_inventory_count_infoService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { locationName?: string, materialLookup?: string }): 
  Promise<{ result: { LocationId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, MaterialId?: number, VendorLotId?: number, Material?: { LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, Packaging?: { Name?: string, ShortName?: string } }[] }, Location?: { Name?: string, ShortName?: string, WarehouseId?: number }, Packaging?: { Name?: string, ShortName?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { locationName?: string, materialLookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { LocationId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, MaterialId?: number, VendorLotId?: number, Material?: { LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, Packaging?: { Name?: string, ShortName?: string } }[] }, Location?: { Name?: string, ShortName?: string, WarehouseId?: number }, Packaging?: { Name?: string, ShortName?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { locationName?: string, materialLookup?: string, $keys: { LocationId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LocationId?: number, LotId?: number, PackagedId?: number, ActivePackagedAmount?: number, MaterialId?: number, VendorLotId?: number, Material?: { LookupCode?: string, ProjectId?: number, PackagingLookups?: { PackagingId?: number, Packaging?: { Name?: string, ShortName?: string } }[] }, Location?: { Name?: string, ShortName?: string, WarehouseId?: number }, Packaging?: { Name?: string, ShortName?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
